import React, { useState, useEffect } from "react";
import {
  Collect,
  Container,
  Divider,
  Point,
  PointContainer,
  StepsContainer,
  StepBox,
  IconBox,
  Number,
  CurrentMilestone,
  Title,
  FinishLine,
  UnfinishLine,
  ShareItemBottomContainer,
  TypeContainer,
  TextBtn,
} from "../ShareSummary.style";
import {
  FinishedStep,
  NotFinishedStep,
  PinkCopyIcon,
  HistoryIcon,
  PinkShareIcon,
} from "@assets";
import { useTranslation } from "react-i18next";
import { Alert } from "@components";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE, PUBLIC_ROUTE } from "@router/route.constants";
import { useDispatch } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { api } from '@api';
import CollectModal from "../CollectModal/CollectModal";
import SuccessModal from "../SuccessModal/SuccessModal";
import { formatShareName } from '@utils';
import copy from "copy-to-clipboard";
import ShareModal from './ShareModal/ShareModal';

const ShareItem = ({ item }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isCollectModalOpen, setIsCollectModalOpen] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [collected, setCollected] = useState(false);
  const [link, setLink] = useState('');
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const {
    type,
    milestone,
    current_count,
    collectable_count,
    can_collect,
    share_id,
  } = item;

  const { t } = useTranslation();

  const lastMileStone = milestone[milestone.length - 1];

  useEffect(() => {
    if (share_id) {
      setLinkFromShareId(share_id)
    }

    //eslint-disable-next-line
  }, [])

  const handleCollectClick = (count) => {
    setIsCollectModalOpen(true)
  }

  const setLinkFromShareId = (shareId) => {
    const domain = window.location.hostname;
    const link = `${domain}/${PUBLIC_ROUTE.SHARE_REGISTER}?share_id=${shareId}`
    setLink(link);
  }

  const copyText = (link) => {
    try {
      copy(link);
      showAlert({
        message: t("common.copied"),
      });
    } catch (error) {
      //create input or text area
      const input = document.createElement("input");
      input.setAttribute("value", link);
      document.body.appendChild(input);
      input.select();
      const result = document.execCommand("copy");
      document.body.removeChild(input);
      if (result) {
        showAlert({
          message: t("common.copied"),
        });
      } else {
        showAlert({
          message: "Failed to copy to clipboard.",
          isError: true,
        });
      }
    }
  };

  const collectShareBonus = () => {
    if (!loading) {
      setLoading(true);
      api
        .collectShareBonus({ share_id })
        .then(() => {
          setLoading(false);
          handleClose();
          setOpenSuccessModal(true);
          setCollected(true)
        })
        .catch((errorMsg) => {
          setLoading(false);
          handleClose();
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  }

  const handleClose = () => {
    !loading && setIsCollectModalOpen(false);
  }

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goToShareHistory = () => {
    navigate(`/${PRIVATE_ROUTE.SHARE_HISTORY}`, {
      state: {
        share_id,
        share_type: type,
      },
    });
  };

  return (
    <TypeContainer>
      <Title> {formatShareName(type)} </Title>

      <Container>

        <StepsContainer>
          {milestone.map((item, index) => {
            let nextMilestone = milestone[index + 1];
            let currentMilestone = item;
            const isWithinCurrentMilestone =
              current_count > currentMilestone && current_count < nextMilestone;
            return (
              <StepBox key={index}>
                <IconBox index={index}>
                  {isWithinCurrentMilestone && (
                    <CurrentMilestone> {current_count}+ </CurrentMilestone>
                  )}

                  {currentMilestone <= current_count ? (
                    <FinishedStep />
                  ) : (
                    <NotFinishedStep />
                  )}

                  {index !== milestone.length - 1 && (
                    <FinishLine
                      width={
                        current_count > nextMilestone
                          ? 100
                          : current_count < currentMilestone
                            ? 0
                            : ((current_count - currentMilestone) /
                              (nextMilestone - currentMilestone)) *
                            100
                      }
                    />
                  )}

                  {index !== milestone.length - 1 && (
                    <UnfinishLine
                      width={
                        current_count > nextMilestone
                          ? 0
                          : current_count < currentMilestone
                            ? 100
                            : ((nextMilestone - current_count) /
                              (nextMilestone - currentMilestone)) *
                            100
                      }
                    />
                  )}
                </IconBox>
                <Number> {item} </Number>
              </StepBox>
            );
          })}
        </StepsContainer>


        {
          !(lastMileStone === current_count && (!can_collect || collected)) && (
            <PointContainer>
              <Point> {t('share.current')} {formatShareName(type).slice(-5)} : <b>{collectable_count || 0} {t("share.views")} </b>  </Point>
              <Collect
                type='default'
                disabled={!can_collect || collected}
                onClick={handleCollectClick}
              >
                {t("common.collect")}
              </Collect>
            </PointContainer>
          )
        }
        <Divider />

        <ShareItemBottomContainer>
          <TextBtn
            onClick={goToShareHistory}
          >
            <HistoryIcon />
            {t("spin.history")} </TextBtn>
          <TextBtn onClick={() => copyText(link)}>
            <PinkCopyIcon />
            {t("common.copy")}
          </TextBtn>
          <TextBtn onClick={() => setShareModalOpen(true)}>
            <PinkShareIcon />
            {t("profile.share")}
          </TextBtn>
        </ShareItemBottomContainer>

        <CollectModal
          open={isCollectModalOpen}
          loading={loading}
          handleClose={handleClose}
          onOk={collectShareBonus}
        />
        <SuccessModal
          open={openSuccessModal}
          onOk={() => setOpenSuccessModal(false)}
        />
        <ShareModal
          link={link}
          open={shareModalOpen}
          handleClose={() => setShareModalOpen(false)}
          copy={copyText}
        />
        <Alert />
      </Container>
    </TypeContainer>
  );
};

export default ShareItem;
